export const formatFileSize = (bytes: number, decimalPoint?: number) => {
  if (bytes == 0) return "0 Bytes";
  var k = 1000,
    dm = decimalPoint || 2,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const getShortenName = (name?: string) => {
  if (name && name.length > 0) {
    let shortName = name.split(" ")[0];
    if (shortName.length > 20) return shortName.substring(0, 20);
    else return shortName;
  } else {
    return "";
  }
};

export const generateUniqueId = () => {
  return `id${Math.random().toString(16).slice(2)}`;
};

export const secondsToHHMMSS = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [
    hours.toString().padStart(2, "0"),
    minutes.toString().padStart(2, "0"),
    seconds.toString().padStart(2, "0"),
  ].join(":");
};
